(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog"] && !window.DesignMode) return;
  try {
    
  var blog_carousel = jQuery('.blog.carousel .row');
  var blog_display = blog_carousel.data('slider-display');
  if(blog_carousel.length > 0 ) {
    if(blog_display == 'all' || ( blog_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      blog_carousel.not('.slick-initialized').slick({
        slidesToShow: blog_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: blog_carousel.data('slider-arrows'),
        dots: blog_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !window.DesignMode) return;
  try {
    

  var product_grid = jQuery('.collection .product-grid');
  product_grid.each(function() {

    var items_to_show = parseInt(jQuery(this).data('list-limit')); // index starts at zero
    var total_items = jQuery(this).find('> div').length;
    var view_more_button = jQuery(this).parent().find('.view-more-button:not([href])');

    if( items_to_show < total_items && view_more_button.length > 1 ) {
      items_to_show = items_to_show - 1;
      view_more_button.show();
      jQuery(this).find('> div:gt('+items_to_show+')').hide();
      jQuery(this).show();
      
      view_more_button.click(function () {
        var list_target = '.grid-'+jQuery(this).data('list-id');
        jQuery(list_target+' div').show();
        jQuery(this).hide();
      });
    }

  });

  jQuery('.collection .product-filters :radio').on('change', function () {

    var current_tags = jQuery('.product-filters').data('current-tags');
    var tag_arr = current_tags.split('+');
    var selected_group = jQuery(this).attr('name');
    var new_tag = "";

    jQuery(tag_arr).each(function(i) {
      var handlize_tag = tag_arr[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      if( !handlize_tag.includes(selected_group) ) {
        new_tag += handlize_tag + "+";
      }
    });

    new_tag += jQuery(this).attr('value');

    var url = jQuery('.collection .product-filters').data('collection-url') +"/"+ new_tag +"#products";
    window.location.href = url;

  });

  jQuery('.collection .product-filters button.clear-filter-group').on('click', function () {

    var current_tags = jQuery('.product-filters').data('current-tags');
    var tag_arr = current_tags.split('+');
    var selected_group = jQuery(this).data('filter-group');
    var new_tag = "";

    jQuery(tag_arr).each(function(i) {
      var handlize_tag = tag_arr[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      if( !handlize_tag.includes(selected_group) ) {
        new_tag += handlize_tag + "+";
      }
    });

    var url = jQuery('.collection .product-filters').data('collection-url') +"/"+ new_tag +"#products";
    window.location.href = url;

  });

  var collection_carousel = jQuery('.collection.carousel .product-grid');
  var carousel_display = collection_carousel.data('slider-display');
  if(collection_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      collection_carousel.not('.slick-initialized').slick({
        slidesToShow: collection_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: collection_carousel.data('slider-arrows'),
        dots: collection_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !window.DesignMode) return;
  try {
    
  var product_grid_carousel = jQuery('.product-grid.carousel .row');
  var product_grid_display = product_grid_carousel.data('slider-display');
  if(product_grid_carousel.length > 0 ) {
    if(product_grid_display == 'all' || ( product_grid_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      product_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: product_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: product_grid_carousel.data('slider-arrows'),
        dots: product_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '0px',
              infinite: true
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-carousel"] && !window.DesignMode) return;
  try {
    
  Helpers.loadScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', function() {
    /* script loaded */
    var target = jQuery('.carousel .carousel-container');
    target.not('.slick-initialized').slick({
      slidesToShow: target.data('slides-to-show'),
      slidesToScroll: target.data('slides-to-show'),
      touchMove: false,
      arrows: target.data('arrows'),
      dots: target.data('dots'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });

  Helpers.loadScript('https://cdn.knightlab.com/libs/juxtapose/latest/js/juxtapose.min.js', function() {
	/* script loaded */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-grid"] && !window.DesignMode) return;
  try {
    
  var content_grid_carousel = jQuery('.content-grid.carousel .row');
  var carousel_display = content_grid_carousel.data('slider-display');
  if(content_grid_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      content_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: content_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: content_grid_carousel.data('slider-arrows'),
        dots: content_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-stats"] && !window.DesignMode) return;
  try {
    
  var content_grid_carousel = jQuery('.content-grid.carousel .d-flex');
  var carousel_display = content_grid_carousel.data('slider-display');
  if(content_grid_carousel.length > 0 ) {
    if(carousel_display == 'all' || ( carousel_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      content_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: content_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: content_grid_carousel.data('slider-arrows'),
        dots: content_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1                                                                             
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-sticky"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('mainNavbar');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('d-none', 'fixed-top');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('d-block', 'fixed-top', 'animate');
      this.header.classList.remove('d-none');
    }

    reset() {
      this.header.classList.remove('d-block', 'fixed-top', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !window.DesignMode) return;
  try {
    
  var product_grid_carousel = jQuery('.products.carousel .row');
  var product_grid_display = product_grid_carousel.data('slider-display');
  if(product_grid_carousel.length > 0 ) {
    if(product_grid_display == 'all' || ( product_grid_display == 'mobile' && parseInt(jQuery(window).width()) < 900) ) {
      product_grid_carousel.not('.slick-initialized').slick({
        slidesToShow: product_grid_carousel.data('slider-slides'),
        slidesToScroll: 1,
        arrows: product_grid_carousel.data('slider-arrows'),
        dots: product_grid_carousel.data('slider-dots'),
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    };
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"]) return;
  try {
    
    /* Listen for form submit and clear cart before continuing */
    document.querySelector('form[action="/cart/add"]').addEventListener("submit",function(evt) {
	  evt.preventDefault();
   
      // Clear Cart first then submit
      fetch('/cart/clear.js', {
        method: 'POST'
      })
      .then(response => response.json())
      .then(data => {
         evt.target.submit();
      })
      .catch((error) => {
        alert('There was an erroring adding your item to cart');
        return false;
      });
    });
    
    /* Change selling plan based on group selected */
    var sellingPlanGroups = [].slice.call(document.querySelectorAll("input[name=selling_plan_group]"));
    var sellingPlan = sellingPlanGroups.map(function (ele) {
      ele.addEventListener("change",function(evt) {
        if(evt.target.value == 0) {
          document.querySelector("input[name=selling_plan]").value = "";
        } else {
          document.querySelector("input[name=selling_plan]").value = document.querySelector('select[name="selling_plan_choice"]').value;
        }
      });
    });

   document.querySelector("input[name=selling_plan]").value = document.querySelector('select[name="selling_plan_choice"]').value
   
    if( jQuery('#mip-carousel div.carousel-hero div').length > 1 ) {
      jQuery('#mip-carousel div.carousel-hero').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        touchMove: true,
        asNavFor: '.carousel-nav',
        arrows: true,
      });
      
      jQuery('#mip-carousel div.carousel-nav').not('.slick-initialized').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.carousel-hero',
        focusOnSelect: true
      });
    };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendations);

      const url = productRecommendations.dataset.url;

      fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendations.innerHTML = recommendations.innerHTML;
        }
		MiniCart.bindUIActions();
      })
      .catch(e => {
        console.error(e);
      });

    };

    const productRecommendations = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
  var testimonials_carousel = jQuery('.testimonials.carousel .slides');
  testimonials_carousel.not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: false
  });

  } catch(e) { console.error(e); }
})();

})();
